import React from "react";
import { styled } from "@mui/system";
import MUIListItem from "@mui/material/ListItem";
import { ListItemProps as ListItemPropsMUI } from "@mui/material/ListItem";
export interface ListItemProps extends ListItemPropsMUI {
  component?: React.ElementType;
}

export const ListItem: (props: ListItemProps) => JSX.Element = styled(
  React.forwardRef<HTMLLIElement, ListItemProps>((props, ref) => (
    <MUIListItem ref={ref} {...props} />
  )),
  {
    name: "ListItem",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiListItem-root": {
    paddingTop: 10,
    paddingBottom: 10,
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid " + theme.palette.primary.interactiveDefault,
      background: theme.palette.primary.surfaceDefault
    }
  },
  "&.MuiListItem-root.MuiListItem-dense": {
    paddingTop: 4,
    paddingBottom: 4
  }
}));
